// extracted by mini-css-extract-plugin
export var locationCard = "_g0-0";